import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import logoImage from '../assets/Frame 1000005895.png';
import mobileLogoImage from '../assets/Frame 1000005957 (1).png';
import mobileProjectImage from '../assets/Frame 1000005951 (1).png';
import mobileLanguageImage from '../assets/Frame 1000005953.png';
import mobileUpgradeImage from '../assets/Frame 1000005952.png';
import ellipse1 from '../assets/Ellipse 1.png';
import ellipse2 from '../assets/Ellipse 2.png';
import upgradeButtonImage from '../assets/Frame 4.png';
import projectsButtonImage from '../assets/Frame 5.png';
import languageButtonImage from '../assets/Frame 1000005885 (1).png';
import profileButtonImage from '../assets/Frame 2 (1).png';
import cardImage from '../assets/Mask group.png';
import LanguageModal from '../components/LanguageModal';
import ProfileMenu from '../components/ProfileMenu';
import LoginModal from '../components/LoginModal.js';
import * as gameService from '../services/gameService';
import { useAuth } from '../context/AuthContext';
import TermsOfService from './TermsOfService';
import PrivacyPolicy from './PrivacyPolicy';

const CARD_TYPES = {
  TRENDING: 'trending',
  APPS: 'apps',
  THREED: '3d'
};

const SearchPage = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState(CARD_TYPES.TRENDING);
  const [cardSearchQuery, setCardSearchQuery] = useState('');
  const [filteredCards, setFilteredCards] = useState([]);
  const [isLanguageModalOpen, setIsLanguageModalOpen] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [currentLanguage, setCurrentLanguage] = useState({ name: 'English', code: 'en-IN', flag: '🇮🇳' });
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [shouldShowLoginModal, setShouldShowLoginModal] = useState(false);
  const [profileImageSrc] = useState("data:image/png;base64,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");
  
  // Fetch games from the backend on component mount
  useEffect(() => {
    const fetchGames = async () => {
      try {
        setLoading(true);
        setError(null);

        // Check if server is available
        const isServerAvailable = await gameService.checkServerAvailability();
        
        if (!isServerAvailable) {
          throw new Error('Server is currently unavailable');
        }
        
        const data = await gameService.fetchGames();
        
        // Transform the game data to match the card structure
        const gameCards = data.map((game, index) => {
          // Create an array of different creator names
          const creatorNames = ['Steve', 'Mark', 'Emma', 'Jessica', 'Alex', 'Jordan', 'Taylor', 'Sam', 'Riley', 'Morgan'];
          // Get a creator name based on the index or a random one if index is out of bounds
          const creatorName = creatorNames[index % creatorNames.length];
          
          return {
            id: game.file_id,
            title: game.name || game.filename,
            imageSrc: game.image || cardImage, // Use backend image if available, fallback to local image
            plays: ((Math.random() * 3) + 6).toFixed(1), // Random play count between 6.0 and 9.0
            remix: 'HTML Game',
            creator: creatorName,
            creatorLink: '#',
            type: CARD_TYPES.TRENDING // Put all games in trending category
          };
        });
        
        setGames(gameCards);
        setLoading(false);
      } catch (err) {
        console.error('Error fetching games:', err);
        
        // Display a more user-friendly error message
        if (err.message.includes('NetworkError') || err.message.includes('Failed to fetch')) {
          setError('Unable to connect to the server. Please check your internet connection or try again later.');
        } else {
          setError(`${err.message}. The server might be temporarily unavailable.`);
        }
        
        // Set some placeholder data for development/testing
        const placeholderGames = [
          {
            id: 'placeholder-1',
            title: 'Demo Game 1',
            imageSrc: cardImage,
            plays: '8.2',
            remix: 'HTML Game',
            creator: 'Steve',
            creatorLink: '#',
            type: CARD_TYPES.TRENDING
          },
          {
            id: 'placeholder-2',
            title: 'Demo Game 2',
            imageSrc: cardImage,
            plays: '7.6',
            remix: 'HTML Game',
            creator: 'Mark',
            creatorLink: '#',
            type: CARD_TYPES.TRENDING
          },
          {
            id: 'placeholder-3',
            title: 'Demo Game 3',
            imageSrc: cardImage,
            plays: '9.1',
            remix: 'HTML Game',
            creator: 'Emma',
            creatorLink: '#',
            type: CARD_TYPES.TRENDING
          }
        ];
        
        setGames(placeholderGames);
        setLoading(false);
      }
    };

    fetchGames();
  }, []);
  
  // Update filtered cards when games, activeTab, or search query changes
  useEffect(() => {
    let results = [...games];
    
    // Filter by tab type
    if (activeTab !== 'all') {
      results = results.filter(card => card.type === activeTab);
    }
    
    // Filter by search query
    if (cardSearchQuery.trim() !== '') {
      const searchLower = cardSearchQuery.toLowerCase();
      results = results.filter(card => 
        card.title.toLowerCase().includes(searchLower) || 
        card.creator.toLowerCase().includes(searchLower) ||
        card.remix.toLowerCase().includes(searchLower)
      );
    }
    
    setFilteredCards(results);
  }, [games, activeTab, cardSearchQuery]);

  // Function to handle Play button click
  const handlePlayGame = (fileId) => {
    navigate(`/play/${fileId}`);
  };

  // Add a new function to handle remixing a game
  const handleRemixGame = async (gameId) => {
    try {
      console.log('Remixing game:', gameId);
      
      // Find the game details from our local state
      const gameToRemix = games.find(game => game.id === gameId);
      const gameTitle = gameToRemix ? gameToRemix.title : 'Remix Project';
      const remixTitle = `${gameTitle} (Remix)`;
      
      // Get user ID - either from current user or guest ID
      const userId = currentUser?.id || 
                    (localStorage.getItem('guestUserId') || 
                    (() => {
                      const newGuestId = `guest-${Date.now()}`;
                      localStorage.setItem('guestUserId', newGuestId);
                      return newGuestId;
                    })());
      
      // Make POST request to the remix API
      const response = await fetch('https://api.lab.battlexo.com/api/v1/html/remix-start', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          file_id: gameId,
          user_id: userId,
          project_name: remixTitle
        }),
      });
      
      if (!response.ok) {
        throw new Error(`Error: ${response.status}`);
      }
      
      const data = await response.json();
      
      // Save to localStorage as a chat session so it appears in projects
      const sessionId = data.session_id || `remix-${Date.now()}`;
      const sessionData = {
        id: sessionId,
        userId: userId,
        title: remixTitle,
        messages: [
          {
            id: Date.now(),
            sender: 'ai',
            text: `I've loaded the "${gameTitle}" game for you to remix. What would you like to modify?`
          }
        ],
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      
      // Store in localStorage with the format used by the projects page
      localStorage.setItem(`chat_${userId}_${sessionId}`, JSON.stringify(sessionData));
      
      // Navigate to chat page with the session ID and HTML content as URL parameters
      navigate(`/chat?remixSessionId=${sessionId}&mode=remix&originalGameId=${gameId}`, {
        state: { 
          htmlContent: data.html,
          remixMode: true,
          remixTitle: remixTitle
        }
      });
      
    } catch (error) {
      console.error('Failed to remix game:', error);
      // You might want to show an error message to the user here
    }
  };

  // Function to render a game card
  const renderGameCard = (game) => (
    <GameCard key={game.id}>
      <GameImageContainer>
     
        <GameImage src={game.imageSrc} alt={game.title} />
      </GameImageContainer>
      <GameInfo>
        <GameTitle>
          {game.title} <InfoIcon>ⓘ</InfoIcon>
        </GameTitle>
        <GameControls>
          <PlayButton onClick={() => handlePlayGame(game.id)}>
            <PlayIcon>▶</PlayIcon> Play
          </PlayButton>
          <PlayButton secondary onClick={() => handleRemixGame(game.id)}>
            <RemixIcon>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                <path d="M3 3v5h5"></path>
                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"></path>
                <path d="M16 21h5v-5"></path>
              </svg>
            </RemixIcon> Re-Work
          </PlayButton>
        </GameControls>
        <GameMeta>
          <MetaText>Type: <MetaLink href="#">{game.remix}</MetaLink></MetaText>
          <MetaText>Created by: <MetaLink href={game.creatorLink}>{game.creator}</MetaLink></MetaText>
        </GameMeta>
      </GameInfo>
    </GameCard>
  );

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  const handleSearchFormSubmit = (e) => {
    e.preventDefault();
    handleSearch();
  };

  const handleArrowClick = () => {
    handleSearch();
  };

  const handleCardSearchChange = (e) => {
    setCardSearchQuery(e.target.value);
  };

  const goToProjects = () => {
    navigate('/projects');
  };

  const goToUpgrade = () => {
    navigate('/upgrade');
  };

  const openLanguageModal = () => {
    setIsLanguageModalOpen(true);
  };

  const closeLanguageModal = () => {
    setIsLanguageModalOpen(false);
  };
  
  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };
  
  const closeProfileMenu = () => {
    setIsProfileMenuOpen(false);
  };
  
  const handleLanguageChange = (language) => {
    setCurrentLanguage(language);
    // You can add code here to change the language in your app
    console.log(`Language changed to: ${language.name} (${language.code})`);
  };

  // Add window resize listener to detect mobile view
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Function to handle search actions
  const handleSearch = () => {
    if (!currentUser && searchQuery.trim()) {
      setIsLoginModalOpen(true);
      setShouldShowLoginModal(true);
      return;
    }
    if (searchQuery.trim()) {
      navigate(`/chat?query=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  // Open login modal directly
  const openLoginModal = () => {
    setIsLoginModalOpen(true);
  };

  // Close login modal and handle post-login navigation
  const closeLoginModal = () => {
    setIsLoginModalOpen(false);
    if (shouldShowLoginModal && currentUser && searchQuery.trim()) {
      // If user just logged in and there was a pending search, execute it
      navigate(`/chat?query=${encodeURIComponent(searchQuery.trim())}`);
      setShouldShowLoginModal(false);
    }
  };




  return (
    <PageContainer>
      <BackgroundEllipse1 src={ellipse1} alt="" />
      <BackgroundEllipse2 src={ellipse2} alt="" />
      
      <Header>
        <LogoContainer>
          <Logo src={isMobile ? mobileLogoImage : logoImage} alt="Logo" />
        </LogoContainer>
        <ButtonContainer>
          {!isMobile && (
            <UpgradeButton onClick={goToUpgrade}>
              <ButtonImage src={upgradeButtonImage} alt="Upgrade" />
            </UpgradeButton>
          )}
          <ProjectsButton onClick={goToProjects}>
            <ButtonImage src={isMobile ? mobileProjectImage : projectsButtonImage} alt="My Projects" />
          </ProjectsButton>
     
          <ProfileButton onClick={currentUser ? toggleProfileMenu : openLoginModal}>
            {currentUser ? (
              <ButtonImage src={profileButtonImage} alt="Profile" />
            ) : (
              <ProfileImage src={profileImageSrc} alt="Profile" className="sc-cxgKzJ WpOOx" />
            )}
          </ProfileButton>
          {isProfileMenuOpen && (
            <ProfileMenu isOpen={isProfileMenuOpen} onClose={closeProfileMenu} />
          )}
        </ButtonContainer>
      </Header>

      {isMobile && (
        <MobileUpgradeButton onClick={goToUpgrade}>
          <ButtonImage src={mobileUpgradeImage} alt="Upgrade" />
        </MobileUpgradeButton>
      )}

      <MainContent>
        <Title>
          {isMobile ? (
            <>
         Howdy, fellow Builder! <br />
        
            </>
          ) : (
            "Howdy, fellow Builder! "
          )}
        </Title>
        {isMobile ? (
          <MobileSubtitle>Let's bring your imagination to life—one game at a time.</MobileSubtitle>
        ) : (
          <Subtitle>Let's bring your imagination to life—one game at a time.</Subtitle>
        )}
        
        <SearchContainer onSubmit={handleSearchFormSubmit}>
          <SearchInput 
            type="text" 
            placeholder="Spark a game. Let AI do the rest" 
            value={searchQuery}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
          />
          <SearchSubmitButton type="submit">
            <ArrowIcon onClick={handleArrowClick}>
            ↑
            </ArrowIcon>
          </SearchSubmitButton>
        </SearchContainer>
      </MainContent>
      
      <WhiteContentContainer>
        <CategoriesContainer>
          <CategoryTabs>
            <CategoryTab 
              active={activeTab === CARD_TYPES.TRENDING} 
              onClick={() => setActiveTab(CARD_TYPES.TRENDING)}
            >
              Trending
            </CategoryTab>
            <CategoryTab 
              active={activeTab === CARD_TYPES.APPS} 
              onClick={() => setActiveTab(CARD_TYPES.APPS)}
            >
              Apps
            </CategoryTab>
            <CategoryTab 
              active={activeTab === CARD_TYPES.THREED} 
              onClick={() => setActiveTab(CARD_TYPES.THREED)}
            >
              3D
            </CategoryTab>
            <CategoryTab 
              active={activeTab === 'all'} 
              onClick={() => setActiveTab('all')}
            >
              All
            </CategoryTab>
          </CategoryTabs>
          <SearchBox>
            <SearchIcon>🔍</SearchIcon>
            <SearchBoxInput 
              type="text" 
              placeholder="Search" 
              value={cardSearchQuery}
              onChange={handleCardSearchChange}
            />
          </SearchBox>
        </CategoriesContainer>

        <TrendingSection>
          <TrendingHeader>
            <SectionTitle>
              {activeTab === CARD_TYPES.TRENDING ? 'Trending Games' : 
               activeTab === CARD_TYPES.APPS ? 'Game Apps' : 'All Games'}
            </SectionTitle>
            <SectionSubtitle>
              {activeTab === CARD_TYPES.TRENDING ? 
                'Create 2D & 3D games, websites, and web apps just by describing them. No coding or downloads required.' :
                activeTab === CARD_TYPES.APPS ? 
                'No game apps available in this category.' :
                'No 3D games available in this category.'}
            </SectionSubtitle>
          </TrendingHeader>

          {loading ? (
            <LoadingMessage>Loading games...</LoadingMessage>
          ) : error ? (
            <ErrorMessage>Error loading games: {error}</ErrorMessage>
          ) : filteredCards.length > 0 ? (
            <GameGrid>
              {filteredCards.map(game => renderGameCard(game))}
            </GameGrid>
          ) : (
            <NoResultsMessage>
              {activeTab === CARD_TYPES.TRENDING 
                ? "No games found matching your search criteria."
                : "No games available in this category. Please check the Trending section."}
            </NoResultsMessage>
          )}
        </TrendingSection>
      </WhiteContentContainer>

      <LanguageModal 
        isOpen={isLanguageModalOpen} 
        onClose={closeLanguageModal} 
        onLanguageChange={handleLanguageChange}
      />

      <LoginModal 
        isOpen={isLoginModalOpen} 
        onClose={closeLoginModal} 
      />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  position: relative;
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  overflow: hidden;
  font-family: 'Space Grotesk', sans-serif;
    isolation: isolate; 
  
  @media (max-width: 768px) {
    padding: 10rem 0;
  }
`;

const BackgroundEllipse1 = styled.img`
  position: absolute;
  top: 1%;
  left: 13%;
  width: 55%;
  z-index: 0;
  
  pointer-events: none;
  mix-blend-mode: normal;

  @media (max-width: 768px) {
   left: -100px;
   height: 300px; 
   width: 500px;
  }
`;

const BackgroundEllipse2 = styled.img`
  position: absolute;
  top: 1%;
  right: 13%;
  width: 55%;
  z-index: 0;
  
  pointer-events: none;
  mix-blend-mode: normal;
  @media (max-width: 768px) {
   right: -100px;
   height: 300px; 
   width: 500px;
  }
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 1.25rem 2rem;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    position: relative;
  z-index: 100;
  
  @media (max-width: 768px) {
    padding: 0.75rem 1rem;
    background-color: white;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    margin-top: 0;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    margin-right: auto;
  }
`;

const Logo = styled.img`
  height: 24px;
  
  @media (max-width: 768px) {
    height: 32px;
  }
`;

const SearchContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 700px;
  margin-top: 1rem;
  border-radius: 20px;
  padding: 2px;
  background-image: linear-gradient(to bottom, #ff6ed8, #7878ff);
  bbox-shadow: 0 -4px 20px rgba(232, 6, 148, 0.2), 0 4px 20px rgba(7, 130, 254, 0.2);
  border: 1px;
  
  @media (max-width: 768px) {
    margin-top: 0;
    border-radius: 10px;
    overflow: hidden;
    background-image: linear-gradient(to bottom, #ff6ed8, #0782FE);
    box-shadow: 0 -4px 20px rgba(232, 6, 148, 0.2), 0 4px 20px rgba(7, 130, 254, 0.2);
    max-width: 100%;
    border: 1px;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 1.5rem 1.75rem;
  padding-right: 4.5rem;
  font-size: 1.25rem;
  border: none;
  border-radius: 18px;
  background: white;
  outline: none;
  color: #666;
  font-family: 'Space Grotesk', sans-serif;
  transition: all 0.3s ease;
  
  &::placeholder {
    color: #888;
    font-weight: 400;
  }
  
  &:focus {
    outline: none;
    box-shadow: 0 0 15px rgba(255, 110, 216, 0.15), 0 0 15px rgba(120, 120, 255, 0.15);
  }
  
  @media (max-width: 768px) {
    padding: 1rem 3rem 1rem 1rem;
    font-size: 0.9rem;
    border-radius: 8px;
    color: #999;
    
    &::placeholder {
      font-size: 0.9rem;
      color: #aaa;
    }
  }
`;

const SearchSubmitButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 56px;
  height: 56px;
  background: #111;
  color: white;
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.2s, background-color 0.2s;
  
  &:hover {
    background-color: #333;
    transform: translateY(-50%) scale(1.05);
  }
  
  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
    right: 8px;
    font-size: 0.8rem;
    background-color: #000;
  }
`;

const ArrowIcon = styled.div`
  position: absolute;
  right: 12px;
  cursor: pointer;
  color: white;
  font-size: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  

`;

// White content container
const WhiteContentContainer = styled.div`
  background-color: white;
  width: 100%;
  border-radius: 0;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.05);
  padding: 0 0 4rem;
  z-index: 5;
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    border-radius: 30px 30px 0 0;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.1);
    margin-top: 0;
    padding: 0 0 2rem;
  }
`;

// Categories section
const CategoriesContainer = styled.div`
  display: flex;
  width: 100vw;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  z-index: 10;
  margin-bottom: 1rem;
  border-top: 1px solid #0D0D0D1A;
  border-bottom: 1px solid #0D0D0D1A;
  position: relative;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    padding: 1rem 1.5rem;
    border-top: none;
    gap: 1rem;
  }
`;

const CategoryTabs = styled.div`
  display: flex;
  gap: 1rem;
  
  @media (max-width: 768px) {
    width: 100%;
    overflow-x: auto;
    padding-bottom: 0.5rem;
    -ms-overflow-style: none;
    scrollbar-width: none;
    
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

const CategoryTab = styled.button`
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: ${props => props.active ? 'white' : '#333'};
  background-color: ${props => props.active ? '#EC0F8F' : 'transparent'};
  border: 1px solid ${props => props.active ? '#EC0F8F' : '#E0E0E0'};
  border-radius: 9999px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  
  &:hover {
    background-color: ${props => props.active ? '#EC0F8F' : '#F5F5F5'};
  }
  
  @media (max-width: 768px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.85rem;
  }
`;

const SearchBox = styled.div`
  position: relative;
  width: 300px;
  
  @media (max-width: 768px) {
    width: 100%;
  }
`;

const SearchIcon = styled.span`
  position: absolute;
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #666;
`;

const SearchBoxInput = styled.input`
  width: 100%;
  padding: 0.5rem 1rem 0.5rem 2.5rem;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 9999px;
  font-size: 0.875rem;
  outline: none;
  
  &:focus {
    border-color: #6b46c1;
  }
`;

// Trending section
const TrendingSection = styled.section`
  width: 100%;
  max-width: 1500px;
  padding: 0 1.5rem;
  margin: 0 auto;
  z-index: 10;
  margin-top: 1rem;
  
  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

const TrendingHeader = styled.div`
  margin-bottom: 2rem;
  display: flex;
  align-items: center;
  
  @media (max-width: 768px) {
    margin-bottom: 1rem;
    flex-direction: column;
    align-items: flex-start;
  }
`;

const SectionTitle = styled.h3`
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 0;
  margin-right: 1rem;
  white-space: nowrap;
  
  @media (max-width: 768px) {
    font-size: 1.2rem;
    margin-bottom: 0.25rem;
  }
`;

const SectionSubtitle = styled.p`
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0;
  
  @media (max-width: 768px) {
    font-size: 0.8rem;
    margin-top: 0;
  }
`;

const GameGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 1.25rem;
  width: 100%;
  margin-top: 1.5rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1rem;
    margin-top: 1rem;
  }
`;

const GameCard = styled.div`
  border-radius: 16px;
  overflow: hidden;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s, box-shadow 0.2s;
  width: 100%;
  border: 1px solid rgba(0, 0, 0, 0.05);
  
  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }
`;

const GameImageContainer = styled.div`
  position: relative;
  width: 100%;
  height: 180px;
  background-color: #000;
  overflow: hidden;
`;

const GameTitle3D = styled.div`
  position: absolute;
  top: 20px;
  left: 20px;
  font-family: 'Space Grotesk', sans-serif;
  font-size: 24px;
  font-weight: 900;
  line-height: 0.9;
  color: #30FC75; /* Neon green color */
  text-shadow: 0 0 5px rgba(48, 252, 117, 0.7);
  z-index: 1;
  letter-spacing: -1px;
  text-transform: uppercase;
`;

const GameImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.9; /* Slightly transparent to show the text better */
`;

const GameInfo = styled.div`
  padding: 1rem;
  background: white;
`;

const GameTitle = styled.h4`
  font-size: 1rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
`;

const InfoIcon = styled.span`
  font-size: 0.875rem;
  color: #666;
  cursor: pointer;
  opacity: 0.7;
`;

const GameControls = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
  
  @media (max-width: 768px) {
    gap: 0.75rem;
  }
`;

const PlayButton = styled.button`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  padding: 0.5rem 0;
  background: #E806941A;
  color: #000;
  border: 1px solid #E80694;
  border-radius: 10px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  
  &:hover {
    background-color: ${props => props.secondary ? '#f8f8f8' : '#FFD0EF'};
  }
  
  @media (max-width: 768px) {
    padding: 0.6rem 0;
  }
`;

const PlayIcon = styled.span`
  font-size: 0.75rem;
`;

const RemixIcon = styled.span`
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  
  svg {
    width: 14px;
    height: 14px;
  }
`;

const GameMeta = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-top: 0.25rem;
`;

const MetaText = styled.div`
  font-size: 0.875rem;
  color: #666;
`;

const MetaLink = styled.a`
  color: #3B82F6;
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

const NoResultsMessage = styled.div`
  text-align: center;
  padding: 3rem;
  font-size: 1.2rem;
  color: #666;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #666;
`;

const ErrorMessage = styled.div`
  text-align: center;
  padding: 40px;
  font-size: 18px;
  color: #f44336;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  
  & > button {
    margin-right: 0;
  }
  
  & > button:not(:last-child) {
    margin-right: 0;
  }
  
  @media (max-width: 768px) {
    background-color: transparent;
    border-radius: 0;
    padding: 0;
    box-shadow: none;
    margin-left: 10px;
  }
`;

const UpgradeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const ButtonImage = styled.img`
  height: 36px;
  width: auto;
  display: block;
  
  @media (max-width: 768px) {
    height: 32px;
  }
`;

const ProjectsButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  
  @media (max-width: 768px) {
    padding: 2px;
  }
`;

const LanguageButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  
  @media (max-width: 768px) {
    padding: 2px;
  }
`;

const ProfileButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 0;
  margin: 0;
  cursor: pointer;
  text-decoration: none;
  
  @media (max-width: 768px) {
    padding: 2px;
  }
`;

const MainContent = styled.main`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 60vh;
  padding: 2rem;
  z-index: 10;
  margin-top: 2rem;
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    min-height: auto;
    padding: 1.5rem 1rem;
    margin-top: 0;
    margin-bottom: 1rem;
    justify-content: flex-start;
  }
`;

const Title = styled.h1`
  font-size: 5rem;
  font-weight: 800;
  color: #000;
  text-align: center;
  margin-bottom: 1rem;
  
  @media (max-width: 768px) {
    font-size: 2.5rem;
    font-weight: 600;
    line-height: 1.2;
    text-align: center;
    align-self: center;
    margin-bottom: 1.5rem;
    width: 100%;
    
    br {
      display: block;
      content: "";
      margin-top: 0.2rem;
    }
  }
`;

const Subtitle = styled.h2`
  font-size: 1.75rem;
  font-weight: 500;
  color: #555;
  text-align: center;
  margin-bottom: 3rem;
  
  @media (max-width: 768px) {
    font-size: 1rem;
    font-weight: 500;
    text-align: center;
    align-self: center;
    margin-bottom: 1.5rem;
    color: #333;
  }
`;

const MobileSubtitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 500;
  color: #333;
  text-align: center;
  margin-bottom: 1.5rem;
  margin-top: -0.75rem;
  width: 100%;
`;

const MobileUpgradeButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  padding: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: auto;
  z-index: 100;
  cursor: pointer;
  
  img {
    height: 36px;
    width: auto;
  }
`;

const ProfileImage = styled.img.attrs({
  className: 'sc-cxgKzJ WpOOx'
})`
  width: 36px;
  height: 36px;
  border-radius: 50%;
`;

export default SearchPage;